/** Background/polling APIs must never log the user out or toast "offline". */

function headerValue(headers: unknown, name: string): string {
  if (!headers || typeof headers !== 'object') return '';
  const rec = headers as { get?: (key: string) => unknown } & Record<string, unknown>;
  if (typeof rec.get === 'function') {
    return String(rec.get(name) ?? rec.get(name.toLowerCase()) ?? '');
  }
  const direct = rec[name] ?? rec[name.toLowerCase()] ?? rec[name.toUpperCase()];
  return direct == null ? '' : String(direct);
}

export function isSilentRequestHeaders(headers: unknown): boolean {
  const value = headerValue(headers, 'X-Silent-Request').trim().toLowerCase();
  return value === 'true' || value === '1';
}

export function isNotificationOrBadgeApiPath(url: string): boolean {
  let path = String(url || '').split('?')[0];
  if (path.includes('://')) {
    try {
      path = new URL(path).pathname;
    } catch {
      // fallback
    }
  }
  path = path.replace(/^\/+/, '/');
  if (path.startsWith('/api/')) {
    path = '/' + path.substring(5);
  }
  if (path === '/notifications' || path.startsWith('/notifications/')) return true;
  if (path === '/admin/notifications' || path.startsWith('/admin/notifications/')) return true;
  if (path.includes('/badges')) return true;
  if (path.includes('/unread-count') || path.endsWith('/unread') || path.includes('/unread')) return true;
  if (isChatUnreadPath(path)) return true;
  if (path === '/my/messages' || path.startsWith('/my/messages')) return true;
  if (path === '/event-frameworks' || path.startsWith('/event-frameworks')) return true;
  if (path === '/organizer/my-organizations' || path.startsWith('/organizer/my-organizations')) return true;
  if (path === '/organizer/org-chat' || path.startsWith('/organizer/org-chat')) return true;
  if (path === '/organization/my-organizers' || path.startsWith('/organization/my-organizers')) return true;
  if (path === '/organization/organizer-chat' || path.startsWith('/organization/organizer-chat')) return true;
  return false;
}

/** Badge polls. A 401 here means the session is missing; it must not refresh or log the user out. */
export function isChatUnreadPath(url: string): boolean {
  let path = String(url || '').split('?')[0];
  if (path.includes('://')) {
    try {
      path = new URL(path).pathname;
    } catch {
      /* keep raw path */
    }
  }
  path = path.replace(/^\/+/, '/');
  if (path.startsWith('/api/')) path = `/${path.substring(5)}`;
  return path.endsWith('/chat/unread') || path.endsWith('/organizer-conversation/unread');
}

export function isSilentOrBackgroundApiRequest(
  url: string,
  config?: { headers?: unknown; silent?: boolean; skipAuthRedirect?: boolean; params?: { silent?: unknown } }
): boolean {
  if (config?.silent || config?.skipAuthRedirect || config?.params?.silent) return true;
  if (isSilentRequestHeaders(config?.headers)) return true;
  return isNotificationOrBadgeApiPath(url);
}

